import {getDataWithPromise} from "root/DataFunctions/BaseDataFns";
import {Globals} from "root/globals";
import {handleAjaxError} from "root/DataFunctions/ErrorHandlingFunctions";


/**
 * Provisions a Google account for the currently signed in user (self service).
 *
 * @param onCompleteFunc
 */
export const provisionNewGoogleAccount = (onCompleteFunc) =>
{
    const url = Globals.APIFolder + '/google/accounts';

    getDataWithPromise ( url, 'POST', {} )
        .then (response =>
        {
            onCompleteFunc (response) ;
        })
        .catch( (jqXHR, textStatus, error) =>
        {
            handleAjaxError( jqXHR, textStatus, error) ;
        });
}